import React from 'react'

import '../BlogPost.css'


function Post1() {
        return (
        <div className='blog-content-body'>
            <hr></hr>
            <br></br>
            <br></br>
            <div className='blog_title'><b>프롤로그</b></div>
            <div className='blog_subtitle'>포트폴리오 사이트</div>
            <br></br>
            <img className='blog_img' src='https://img1.daumcdn.net/thumb/R1280x0/?fname=http://t1.daumcdn.net/brunch/service/user/dlxY/image/d44SpzwYT5sKa-LSPFPkoLGGgZ8.jpg'
            width="100%"></img>
            <br></br>
            <br></br>
            <div className='article'>
            <b>“포트폴리오는 pdf면 그만이지 사이트를 굳이?” 라고 묻는이들도 많았다.</b> 
            <br></br>pdf는 그동안 걸어온 길을 너무나도 단편적인 면을 보여준다. 
            주니어 디자이너의 경우 이러한 점을 보완하기 위해, 개성이 너무많이 묻은
            포트폴리오 편집을 보여준다던가, 많은 내용을 꾹꾹 눌러담은 눈아픈 작품 모음집을 만든다. 
            <br></br>
            <br></br><b>이건 본인도 마찬가지였다.</b>
            <br></br>
            <br></br>기회가 닿아 타인의 포트폴리오 pdf를 읽어볼 기회가 생겼는데, 
            &nbsp;남의 <b>작품을 읽는건 생각보다 상당히 귀찮았다.</b>
            &nbsp;스크롤 하며 작품에 빼곡히 채워진 글은 한줄이상 읽기가 어렵다. 
            작품 사진만 보는데도 인지 과부화가 걸릴 지경이다.
            <br></br>
            <br></br>내가 만약 채용담당자라면, 
            수많은 지원자의 작품을 스크롤하는 행위 자체가 꽤나 피로하겠다고 생각했다.
            이외에도, 커버부터 화려하면 작품을 보기도 전에 피곤해진다. 
            내용도 화려할것이 안봐도 보이니까..
            원하는 작품이 빨리 보이지 않으면, 중간에 창을 닫고 휴지통으로 버리기도 했다.
            <br></br>
            <br></br>지원자는 자신의 작품을 상대방이 꼼꼼이 정성껏 봐줄것이라 생각하고 화려하게 최대한 많이 넣지만,&nbsp; 
            상대방은 업무가 늘어나 모든게 피로할 뿐이다.. 
            <br></br>
            <br></br><b>이날 반성의 사이트를 만들게 된다.</b>
            </div>
            <br></br>
            <br></br>
            <br></br>
            <hr></hr>
            <br></br>
            <br></br>
            <br></br>
            <div className='blog_title'><b>#1</b></div>
            <div className='blog_subtitle'>사이트 리브랜딩</div>
            <br></br>
            <img className='blog_img' src='https://img1.daumcdn.net/thumb/R1280x0/?fname=http://t1.daumcdn.net/brunch/service/user/dlxY/image/g0njpfRXfAdGt4eRxl7hFATz_d4.png'
            width="100%"></img>
            <br></br>
            <br></br>
            <div className='article'>
            <b>2021년까지 사용했던 포트폴리오 사이트 "puni"는</b> 
            <br></br>그동안 필자가 해온 모든 작품을 보기 좋게 아카이빙하기 위해 개설하였다.
            <br></br>기존 사이트 링크: <a href='https://puni929.wixsite.com/puni/home' target={'_blank'}>puni.site</a>
            <br></br>
            <br></br>일찍이 사이트를 만들어둔 만큼, 
            시스템을 이용해 본 사용자들에게 정량적인 조사를 할 수 있었다. 
            <br></br><span className='tip'>*일면식이 아예 없던 외주 업체, 클라이언트, 면접관, 여러 지인들 등등</span>
            <br></br>여기서 얻었던 인사이트는 다음과 같았다.
            <br></br>
            <br></br><b>1.</b> 세부 분야가 너무 많아서 작품을 찾는 게 어렵다 
            <br></br><b>2.</b> 디자인 시스템이 부재해 통일성이 없다
            <br></br><b>3.</b> BX가 확실하지 않아 집중되지 않는다.
            <br></br>
            <br></br><b>pain point</b>
            <br></br>인터뷰만 보았을 때 선택과 집중이 되지 않았다고 결론이 날 수 있겠지만,
            &nbsp;핵심적인 원인은 <b>선택과 포기가 적절하지 않았다</b>는 데에 있다.
            <br></br>
            <br></br>puni의 사이트는 디자이너의 포트폴리오 사이트가 아닌 그래픽 아티스트 사이트이기도 했다.
            &nbsp;그러나 본업이 작가가 아닌 디자이너라는 점에서,
            &nbsp;<b>시간이 지남에 따라 Design 섹션 콘텐츠 양만 비대해지게 되는 것을 간과했다.</b>
            &nbsp;다른 섹션과 콘텐츠 양의 밸런스를 무리하게 맞추다 보니, 
            &nbsp;해당 영역 내부에서 혼란을 야기했던 것이다.
            &nbsp;핵심 문제를 디테일하게 확인하기 위해 6명의 정성적 조사를 추가로 진행하였고,  
            &nbsp;그중 가장 와닿았던 답변이 있다.
            <br></br>
            <br></br><b>“작품 하나하나 다 읽으면 퇴근 못한다. 원하는 것만 빨리빨리 보여줬으면 좋겠어”</b>
            <br></br><b>“심플한 건 좋지만, 당신이 궁금해지는 사이트였으면 더 좋겠습니다”</b>
            <br></br>
            <br></br>
            <img className='blog_img' src='https://img1.daumcdn.net/thumb/R1280x0/?fname=http://t1.daumcdn.net/brunch/service/user/dlxY/image/DpKyFcu01IA9Fj11zv7CL_EnLfQ.png'
            width="100%"></img>
            <br></br>
            <br></br><b>이렇게 진행한 UX리서치를 통해 프로젝트의 목표를 설정했다.</b>
            <br></br>작품만 돋보이도록 깔끔하게, 사용성이 쉽도록 조작이 단순하게, 
            &nbsp;많은 작품 중 원하는 것만 빨리 볼 수 있도록 유도하고, 성향과 아이덴티티가 잘 드러나는,
            &nbsp;차별성 있는 생각이 보이는 포트폴리오 사이트로!
            </div>
            <br></br>
            <br></br>
            <br></br>
            <hr></hr>
            <br></br>
            <br></br>
            <br></br>
            <div className='blog_title'><b>#2</b></div>
            <div className='blog_subtitle'>리뉴얼</div>
            <br></br>
            <img className='blog_img' src='https://img1.daumcdn.net/thumb/R1280x0/?fname=http://t1.daumcdn.net/brunch/service/user/dlxY/image/1t69kaFVR3jTWq-Zrfr1zrCKICo.png'
            width="100%"></img>
            <br></br>
            <br></br>
            <div className='article'>
            <b>2022년 웹사이트 PUNI는 DISP라는 디자이너 사이트와 분리된다.</b> 
            <br></br>
            <br></br>uiux의 문제점을 개선하기 이전에, bx로 구분이 되지 않는다면 사이트를 개선한다 해도 
            &nbsp;puni의 정체성은 여전히 모호하게 남을 거라 판단하였다.
            &nbsp;이러한 이유로, 그래픽 아티스트가 아닌 디자이너로써의 아이덴티티를 분리시키기 위해 
            &nbsp;<b>브랜딩을 다시 진행하게 되었다.</b>
            <br></br>
            <br></br>
            <img className='blog_img' src='https://img1.daumcdn.net/thumb/R1280x0/?fname=http://t1.daumcdn.net/brunch/service/user/dlxY/image/QQjCiBS1J5xe_rqS4N2ZGqdmo_s.jpg'
            width="100%"></img>
            <br></br>
            <br></br><b>"스스로는 어떤 디자이너인가?"</b>
            <br></br>많은 디자인 분야를 알고 있다는 건, 분명한 장점이다.
            &nbsp;시각디자인, 미디어디자인, 패션디자인을 전공했다.
            &nbsp;다양한 분야 사람들의 니즈를 쉽게 이해할 수 있고, 많은 곳에서 얻을 수 있는 인사이트는
            &nbsp;더 큰 결과를 낼 수 있다. 하지만 모두를 이해하느라 정확한 결과로 정리하지 못하면
            &nbsp;결과가 지저분해지기도 한다. 이것을 약국에 비유했다.
            <br></br><br></br>
            <img className='blog_img' src='https://img1.daumcdn.net/thumb/R1280x0/?fname=http://t1.daumcdn.net/brunch/service/user/dlxY/image/YafJFKRIPoKM_dvLOQNwvP7CzB8.jpg'
            width="100%"></img>
            <br></br>
            <br></br><b>약이라는 단어를 디자인으로 바꾸었을 때, 내가 생각하는 디자인의 정의가 드러난다.</b>
            &nbsp;알약은 섞으면 새로운 효과가 생기지만 남용하면 독이 된다. 이런 것들을 잘 다루기 위해서는 각각의 알약의
            &nbsp;효능과 사용성을 잘 알고 혼합했을 때 어떤 경우가 발생하는지 면밀히 연구해야 한다. 
            &nbsp;디자인도 마찬가지,
            &nbsp;융합을 부적절하게 사용하면 애매하거나 지저분한 작업이 된다.
            </div>
            <br></br>
            <br></br>
            <br></br>
            <hr></hr>
            <br></br>
            <br></br>
            <br></br>
            <div className='blog_title'><b>#3</b></div>
            <div className='blog_subtitle'>프로세스</div>
            <br></br>
            <br></br>
            <div className='article'>
            <b>Where</b> 
            <br></br>어디서 사이트를 활용할 것인가?
            <br></br>:디자이너를 필요로 하는 모든 사람들과 구역에서.
            <br></br>
            <br></br><b>When</b>
            <br></br>언제 사이트를 사용한 것인가?
            <br></br>:디자인 작업을 하고 싶어 질 때.
            <br></br>
            <br></br><b>Who</b>
            <br></br>어떤 디자이너 디자인인가?
            <br></br>:많은 분야를 알고 있지만 균형 잡힌 디자인을 그리는 디자이너이다.
            <br></br>
            <br></br><b>How</b>
            <br></br>어떻게 사용자를 설득할 것인가?
            <br></br>:많은 분야가 잘 정리되어 있고, 융합도 가능한 콘셉트로 표현한다.
            <br></br>
            <br></br><b>What</b>
            <br></br>이를 무엇으로 표현할 것인가?
            <br></br>:다양한 알약을 섞고 필요한 이들에게 효과가 있는 약을 만드는 조제실.
            <br></br>
            <br></br><b>Why</b>
            <br></br>왜 그렇게 전달해야 하는가?
            <br></br>:조제실이라는 장소 자체가 깔끔하고 심플해서 수납해 둔 약이 잘 보이는 방식이, 
            &nbsp;다양한 분야의 디자인작품을 정리하는 심플한 콘셉트로 활용하기 적절하다.
            </div>
            <br></br>
            <br></br>
            <br></br>
            <hr></hr>
            <br></br>
            <br></br>
            <br></br>
            <div className='blog_title'><b>#4</b></div>
            <div className='blog_subtitle'>보여줄 것 vs 보여주고 싶은 것</div>
            <br></br>
            <br></br>
            <div className='article'>
            <br></br>패스트 캠퍼스라는 플랫폼에서 송민승 디자이너의 강의를 들은 적이 있다.
            &nbsp;트위터 로그인을 디자인을 예시로 시연하던 영상을 보던 도중 기억에 남는 말을 들었다.
            <br></br>
            <br></br><b>"계정이 있는 사용자는 어떻게든 로그인 버튼을 찾아냅니다"</b>
            <br></br>
            <br></br>회원가입을 원하는 사용자가 버튼을 찾지 못해 화면을 이탈하는 것이 더 위험하다는 내용을 듣고
            &nbsp;편리함의 기준도 타깃을 명확히 설정해야 한다는 것을 느꼈다.
            &nbsp;<b>이 사이트에 꼭 필요한 인사이트였다.</b>
            <br></br>
            <br></br>처음에는 영상으로 시선을 끌고, 다음에는 이력을 확인할 수 있는 About 버튼을 제일 메인으로 내세웠다. 
            &nbsp;이력을 확인하고 작품을 구경하고 뒷이야기를 듣는 게 가장 좋은 시나리오라고 생각하고 구상했던 설계는
            &nbsp;클라이언트, 심사관, 면접자 등 모두가 이미 <b>필자의 이력을 보고 사이트에 접속한다는 사실을 간과한 구성이었다.</b>
            &nbsp;&nbsp;광고가 되었든 이력서가 되었는 작품집을 보여주기 위해 먼저 건네는 서류에는 
            &nbsp;성별 이름 이메일주소 등등 상대방이 원하는 정보에 맞추어 이력서류를 전달하게 된다.
            &nbsp;이미 정보를 받은 입장에서 또다시 사이트에 들어와 이력을 확인할 필요는 없다.
            <br></br>
            <br></br><b>그렇다면 작품집을 먼저 보여주는 것이 BEST일까?</b>
            <br></br>로그인을 원하는 계정 보유자가 어떻게든 버튼을 찾듯, 작품 확인을 원하는 사용자의 경우 어떻게든 작품집을
            &nbsp;찾아낼 것이다. 단순한 구조의 사이트 맵이기 때문에 경로도 어렵지 않다. 
            <br></br>
            <br></br>그렇게 내린 결론은 이렇다
            &nbsp;<b>"작품집을 메인으로"</b>
            <br></br>
            &nbsp;많은 작품이 궁금한 이들에게, 혹은 누군가의 빠른 퇴근을 위해
            &nbsp;사용자가 원하는 카테고리의 작품집을 읽게 하는 것이 가장 큰 목표설정하여 홍보 영상 다음으로 앞에 오게 되었다.
            </div>
            <br></br>
            <br></br>
            <hr></hr>
            <br></br>
            <br></br>
            <div className='blog_title'><b>에필로그</b></div>
            <div className='blog_subtitle'>디자이너는 꾸미는 사람이 아니라 <br></br>생각하는 사람이다</div>
            <br></br>
            <br></br>
            <img className='blog_img' src='https://img1.daumcdn.net/thumb/R1280x0/?fname=http://t1.daumcdn.net/brunch/service/user/dlxY/image/tnFatxhrIqg-SDd3_IQvG5TMs-4.png'
            width="100%"></img>
            <br></br>
            <br></br>
            <div className='article'>
            PUNI사이트를 만들었지만. 아무리 만족스럽게 작업했다고 한들,
            &nbsp;읽는 사람이 불편하면 그저 자기만족에 불과하다는 것을 깨달았다.
            <br></br>
            <br></br>Focus가 스스로에서 타인으로 이동하게 되면 높은 효율로 견고한 결과물을 낼 수 있다는 점은 
            &nbsp;꽤나 값진 경험이다. DISP사이트도 시간이 흐르면 다시 불편해질 것이다. 그때가 되면 미련 없이,
            &nbsp;다시 리서치를 하고 리뉴얼을 할 예정이다. 사이트는 소통 매개체일 뿐 나를 전달하는 데에 중점을 둘 거니까.
            </div>

        </div>
    )
}

export default Post1




